module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAACE4AAAhOAFFljFgAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAABtSURBVHja7NqxDQAhDARB91+bezIV8EJCgHgm2NwTXeKoqvhzAfg6MDNHqk4xGyAgICAgICAgICAgICAgICAg4FngxyFXBQgICHgGaAcBAQEBAQEBAQEBAQEBAQEBAQF3AP1sA66tAQAA//8DAO6Q0j+GRnW+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/page/lesson/lessonware/add.png
// module id = /pu0
// module chunks = 1